const QueryUtil = (function () {
	return {
		parse: function (url) {
			const anchor = document.createElement('a');
			anchor.href = url;
			const query = anchor.search.substring(1);

			if (query.length === 0) {
				return [];
			}

			const vars = query.split('&');
			const result = [];

			for (let i = 0; i < vars.length; i++) {
				const pair = vars[i].split('=');
				result.push({
					name: decodeURIComponent(pair[0]),
					value: decodeURIComponent(pair[1])
				});
			}

			return result;
		},
		serialize: function (params) {
			return $.param(params);
		},
		find: function (params, name) {
			return params.find(param => param.name === name);
		},
		findIndex: function (params, name) {
			return params.findIndex(param => param.name === name);
		},
		uniqualize: function (params) {
			const reversed_params = [...params].reverse();
			return reversed_params.filter((param, idx) => this.findIndex(reversed_params, param.name) === idx).reverse();
		},
		build: function (params) {
			const serialized = this.serialize(params);
			let url = location.href;
			if (url.indexOf('?') !== -1) {
				url = url.substr(0, url.indexOf('?'));
			}
			url += `?${serialized}`;

			return url;
		}
	};
})();

export default QueryUtil;